import React from 'react';
import classNames from 'classnames';
import styles from './PillCell.module.css';

type PillCellProps = {
  label: string;
  className?: string;
};

export const PillCell: React.FC<PillCellProps> = ({ label, className }) => {
  return <span className={classNames(styles.pill, className)}>{label}</span>;
};
